/* eslint-disable @typescript-eslint/prefer-reduce-type-parameter */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useCallback } from 'react';
import './PackageCount.less';
import { BankOutlined, DownOutlined, RightOutlined, ShopOutlined } from '@ant-design/icons';
import { List, Popover } from 'antd';
import { apiClient, PalettCount, TruckOutlined, useAuth } from '@isocel/front-common';

import { useDashboardContext } from '../../../context/DashboardContext';
import { BaseModel, Package, StoreUser } from '../../../queries/api/types';
import { usePalettes } from '../../../queries/palette';
import { useWarehouses } from '../../../queries/warehouse';

interface PackageData {
    package: Package;
    count: number;
    debt: number;
    parcPalett: string;
    returnedCount: number;
    recievedCount: number;
}

interface PackageCountProps {
    onCounterSelect?: (counter: 'list' | 'debtList' | `parc-${string}` | null) => void;
    hideDetailLists?: boolean;
}

const PackageCount: React.FC<PackageCountProps> = ({ onCounterSelect, hideDetailLists }) => {
    const [packages, setPackages] = useState<PackageData[]>([]);
    const [, setTotalDebt] = useState<number>(0);
    const [parcPalettData, setParcPalettData] = useState<PackageData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [warehouseCounterData, setWarehouseCounterData] = useState<
        Array<{ type: string; model: string; count: number }>
    >([]);
    const [totalWarehouseCount, setTotalWarehouseCount] = useState<number>(0);
    const {
        selectedStoreIds,
        selectedSupplierIds,
        setSelectedStoreIds,
        selectedParcPalettIds,
        selectedStartDate,
        selectedEndDate,
        selectedVoucherStatus,
        selectedPackageIds,
        selectedWarehouseIds,
        storeFilterManuallySet,
    } = useDashboardContext();
    const { user } = useAuth();
    const storeId = (user as StoreUser)?.store;
    const organizationId = user?.organization?.id;
    const { data: palettesData } = usePalettes(user?.organization?.id || '');
    useWarehouses(); // preload warehouses cache
    const [filteredParcPalett, setfilteredParcPalett] = useState<BaseModel[]>([]);
    const [debtPackageData, setDebtPackageData] = useState<PackageData[]>([]);

    const [visibleList, setVisibleList] = useState<'list' | 'debtList' | 'warehouseList' | `parc-${string}` | null>(
        null
    );

    // Effect to set default store ID when selectedStoreIds is empty and storeId is available
    useEffect(() => {
        if (!storeFilterManuallySet && selectedStoreIds.length === 0 && storeId) {
            setSelectedStoreIds([storeId]);
        }
    }, [storeId, setSelectedStoreIds, storeFilterManuallySet]); // Use storeFilterManuallySet to coordinate with other components

    // Effect to update filtered palettes when palettesData changes
    useEffect(() => {
        if (palettesData) {
            setfilteredParcPalett(palettesData);
        }
    }, [palettesData]);

    // Main effect to handle data fetching based on filters and voucher status
    useEffect(() => {
        if (!storeFilterManuallySet && selectedStoreIds.length === 0 && storeId) {
            return;
        }

        // Early return for "Utilisé" or "Expiré" only
        if (
            (selectedVoucherStatus.includes('Utilisé') || selectedVoucherStatus.includes('Expiré')) &&
            !selectedVoucherStatus.includes('Non Utilisé')
        ) {
            setPackages([]);
            setTotalDebt(0);
            setParcPalettData([]);
            setDebtPackageData([]);
            setLoading(false);
            return;
        }

        // Only fetch debt if "Non Utilisé" is selected
        if (selectedVoucherStatus.includes('Non Utilisé')) {
            fetchTotalDebt(selectedStoreIds, selectedSupplierIds, selectedPackageIds);
            setPackages([]);
            setParcPalettData([]);
            return;
        }

        fetchPackages(selectedStoreIds, selectedPackageIds);
        fetchTotalDebt(selectedStoreIds, selectedSupplierIds, selectedPackageIds);
        fetchParcPalettCount(selectedParcPalettIds, selectedPackageIds);
        fetchWarehouseCount(selectedWarehouseIds, selectedPackageIds);
    }, [
        selectedPackageIds,
        selectedEndDate,
        selectedParcPalettIds,
        selectedWarehouseIds,
        selectedStartDate,
        selectedStoreIds,
        selectedSupplierIds,
        selectedVoucherStatus,
        storeId,
        user?.organization?.id,
    ]);

    const fetchPackages = async (storeIds: string[], packageIds: string[]) => {
        try {
            setLoading(true);
            const response = await apiClient().get('/packageCounts', {
                params: {
                    storeIds: storeIds.join(','),
                    packageIds: packageIds.join(','),
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    organizationId: storeId ? '' : user?.organization?.id,
                },
            });
            setPackages(response.data);
        } catch (error: any) {
            setError('Failed to fetch packages');
        } finally {
            setLoading(false);
        }
    };

    const fetchTotalDebt = async (storeIds: string[], supplierIds: string[], packageIds: string[]) => {
        try {
            setLoading(true);
            const response = await apiClient().get('/packageDebtTotal', {
                params: {
                    storeIds: storeIds.join(','),
                    supplierIds: supplierIds.join(','),
                    packageIds: packageIds.join(','),
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                    organizationId: storeId ? '' : user?.organization?.id,
                },
            });
            setTotalDebt(response.data.totalDebt);
            setDebtPackageData(response.data.debts);
        } catch (error: any) {
            setError('Failed to fetch total debt');
        } finally {
            setLoading(false);
        }
    };

    const fetchParcPalettCount = async (parcPalettIds: string[], packageIds: string[]) => {
        try {
            setLoading(true);
            const response = await apiClient().get('/parcsPaletteTotal', {
                params: {
                    organizationId: user?.organization?.id,
                    parcPalettIds: parcPalettIds.join(','),
                    packageIds: packageIds.join(','),
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                },
            });
            setParcPalettData(response.data);
        } catch (error: any) {
            setError('Failed to fetch packages');
        } finally {
            setLoading(false);
        }
    };

    const fetchWarehouseCount = async (warehouseIds: string[], packageIds: string[]) => {
        try {
            const response = await apiClient().get('/warehouseCounters', {
                params: {
                    organizationId: user?.organization?.id,
                    warehouseIds: warehouseIds.join(','),
                    packageIds: packageIds.join(','),
                    startDate: selectedStartDate,
                    endDate: selectedEndDate,
                },
            });
            const rows: Array<{ type: string; model: string; count: number }> = (response.data ?? []).map((r: any) => ({
                type: r.type ?? r.package?.type?.name ?? '',
                model: r.model ?? r.package?.model?.name ?? '',
                count: Number(r.count ?? r.quantity ?? 0),
            }));
            setWarehouseCounterData(rows);
            setTotalWarehouseCount(rows.reduce((s, r) => s + r.count, 0));
        } catch {
            // silently fail — warehouse counter is not critical
        }
    };

    const refreshPackageCounts = useCallback(async () => {
        // Refresh all package count data
        if (
            (selectedVoucherStatus.includes('Utilisé') || selectedVoucherStatus.includes('Expiré')) &&
            !selectedVoucherStatus.includes('Non Utilisé')
        ) {
            setPackages([]);
            setTotalDebt(0);
            setParcPalettData([]);
            setDebtPackageData([]);
            setLoading(false);
            return;
        }

        // Only fetch debt if "Non Utilisé" is selected
        if (selectedVoucherStatus.includes('Non Utilisé')) {
            await fetchTotalDebt(selectedStoreIds, selectedSupplierIds, selectedPackageIds);
            setPackages([]);
            setParcPalettData([]);
            return;
        }

        await fetchPackages(selectedStoreIds, selectedPackageIds);
        await fetchTotalDebt(selectedStoreIds, selectedSupplierIds, selectedPackageIds);
        await fetchParcPalettCount(selectedParcPalettIds, selectedPackageIds);
        await fetchWarehouseCount(selectedWarehouseIds, selectedPackageIds);
    }, [selectedVoucherStatus, selectedStoreIds, selectedSupplierIds, selectedPackageIds, selectedParcPalettIds]);

    // Store refresh function in context (we'll need to add this to DashboardContext)
    const { refreshPackageCount } = useDashboardContext();
    useEffect(() => {
        if (refreshPackageCount) {
            refreshPackageCount.current = refreshPackageCounts;
        }
    }, [refreshPackageCounts, refreshPackageCount]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const toggleListVisibility = () => {
        setVisibleList((prev) => {
            const next = prev === 'list' ? null : 'list';
            onCounterSelect?.(next);
            return next;
        });
    };

    const toggleDebtListVisibility = () => {
        setVisibleList((prev) => {
            const next = prev === 'debtList' ? null : 'debtList';
            onCounterSelect?.(next);
            return next;
        });
    };
    const toggleWarehouseListVisibility = () => {
        setVisibleList((prev) => {
            const next = prev === 'warehouseList' ? null : 'warehouseList';
            onCounterSelect?.(next as any);
            return next;
        });
    };
    const toggleParcListVisibility = (parcId: string) => {
        setVisibleList((prev) => {
            const next = prev === `parc-${parcId}` ? null : (`parc-${parcId}` as const);
            onCounterSelect?.(next);
            return next;
        });
    };

    const groupedData = (packages || []).reduce<
        Record<
            string,
            Array<{ model: string; count: number; debt: number; recievedCount: number; returnedCount: number }>
        >
    >((acc, pkg) => {
        const packageName = pkg.package.type.name;
        if (!acc[packageName]) {
            acc[packageName] = [];
        }
        acc[packageName].push({
            model: pkg.package.model.name,
            count: pkg.count,
            debt: pkg.debt,
            recievedCount: pkg.recievedCount,
            returnedCount: pkg.returnedCount,
        });
        return acc;
    }, {});
    const packageData = Object.entries(groupedData).map(([name, details]) => {
        const totalRecievedCount = details.reduce((sum, item) => sum + (item.recievedCount || 0), 0);
        const totalReturnedCount = details.reduce((sum, item) => sum + (item.returnedCount || 0), 0);
        return {
            name,
            details,
            totalCount: details.reduce((sum, item) => sum + item.count, 0),
            recievedCount: totalRecievedCount,
            returnedCount: totalReturnedCount,
            percentage: totalRecievedCount > 0 ? Math.round((totalReturnedCount / totalRecievedCount) * 100) : 0,
        };
    });
    packageData.sort((a, b) => b.totalCount - a.totalCount);

    const totalCount = packageData.reduce((sum, item) => sum + item.totalCount, 0);

    const groupedDebtData = (debtPackageData || [])
        .filter((pkg) => !pkg.package.rental)
        .reduce<Record<string, Array<{ model: string; count: number; debt: number }>>>((acc, pkg) => {
            const packageName = pkg.package.type.name;
            if (!acc[packageName]) {
                acc[packageName] = [];
            }
            acc[packageName].push({
                model: pkg.package.model.name,
                count: pkg.count,
                debt: pkg.debt,
            });
            return acc;
        }, {});

    const packageDebt = Object.entries(groupedDebtData).map(([name, details]) => {
        return {
            name,
            details,
            debt: details.reduce((sum, item) => sum + item.debt, 0),
        };
    });

    packageDebt.sort((a, b) => b.debt - a.debt);

    const filteredTotalDebt = packageDebt.reduce((sum, item) => sum + item.debt, 0);

    // Filter parcPalett based on selectedParcPalettIds
    const filteredParcPalettes = selectedParcPalettIds.length
        ? filteredParcPalett.filter((parc) => selectedParcPalettIds.includes(parc.id))
        : filteredParcPalett;

    const groupedParcData = parcPalettData.reduce<Record<string, typeof parcPalettData[0]>>((acc, pkg) => {
        if (!acc[pkg.parcPalett]) {
            acc[pkg.parcPalett] = { ...pkg, count: 0 };
        }
        acc[pkg.parcPalett].count += pkg.count;
        return acc;
    }, {});

    const parcPaletteData = filteredParcPalettes.map((parc) => ({
        ...parc,
        ...groupedParcData[parc.id],
    }));

    // const packageParcTypes = parcPalettData.map((pkg) => ({
    //     name: pkg.package.type.name,
    //     details: [{ model: pkg.package.model.name, count: pkg.count, parcPalett: pkg.parcPalett }],
    //     count: pkg.count,
    //     parcPalett: pkg.parcPalett,
    // }));

    const matchingTypes = parcPalettData.reduce<
        Array<{
            name: string;
            details: Array<{ model: string; count: number }>;
            count: number;
            parcPalett: string;
        }>
    >((acc, pkg) => {
        let group = acc.find((item) => item.parcPalett === pkg.parcPalett && item.name === pkg.package.type.name);
        if (!group) {
            group = {
                name: pkg.package.type.name,
                details: [],
                count: 0,
                parcPalett: pkg.parcPalett,
            };
            acc.push(group);
        }
        group.details.push({ model: pkg.package.model.name, count: pkg.count });
        group.count += pkg.count;
        return acc;
    }, []);
    return (
        <div className="dashboard">
            <div className="cards-container">
                <div className="flex col ">
                    {!selectedVoucherStatus.includes('Non Utilisé') && (
                        <>
                            <div
                                className={`card card-total ${visibleList === 'list' ? 'highlight' : ''} ${
                                    storeId ? 'open' : ''
                                }`}
                                onClick={() => {
                                    toggleListVisibility();
                                }}
                            >
                                <div className="text-primary font-24 w-48">
                                    <ShopOutlined />
                                </div>
                                <div className="flex justify-between items-center w-full">
                                    <div
                                        className="flex justify-between items-center"
                                        onClick={() => {
                                            const listElement = document.querySelector('.kpi-list');
                                            if (listElement) {
                                                listElement.classList.toggle('hidden');
                                            }
                                        }}
                                    >
                                        <div>
                                            <h5 className="m-0 text-medium-grey">Compteur Magasins</h5>
                                            <div className="card-data font-20">
                                                {storeId
                                                    ? totalCount >= 0
                                                        ? totalCount
                                                        : `- ${Math.abs(totalCount)}`
                                                    : organizationId
                                                    ? totalCount > 0
                                                        ? `- ${totalCount}`
                                                        : Math.abs(totalCount)
                                                    : ``}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className="icon-toggle items-center"
                                        onClick={() => {
                                            const listElement = document.querySelector('.kpi-list');
                                            if (listElement) {
                                                listElement.classList.toggle('hidden');
                                                const iconElement = document.querySelector('.icon-toggle');
                                                if (iconElement) {
                                                    iconElement.classList.toggle('open');
                                                }
                                            }
                                        }}
                                    >
                                        <div
                                            className={`icon-toggle items-center ${
                                                visibleList === 'list' ? 'open' : ''
                                            }`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setVisibleList((prev) => (prev === 'list' ? null : 'list'));
                                            }}
                                        >
                                            {visibleList === 'list' ? (
                                                <DownOutlined className="text-primary" />
                                            ) : (
                                                <RightOutlined className="text-primary" />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <style>
                                {`
                                .kpi-list.hidden {
                                    display: none;
                                }
                                .card.open + .kpi-list {
                                    display: block;
                                }
                            `}
                            </style>
                        </>
                    )}
                    <>
                        <div
                            className={`card card-total ${visibleList === 'debtList' ? 'highlight' : ''} ${
                                storeId ? 'open' : ''
                            }`}
                            onClick={() => {
                                toggleDebtListVisibility();
                            }}
                        >
                            <div className="text-primary font-24 w-48">
                                <TruckOutlined />
                            </div>
                            <div className="flex justify-between items-center w-full">
                                <div
                                    className="flex justify-between items-center"
                                    onClick={() => {
                                        const listElement = document.querySelector('.debt-list');
                                        if (listElement) {
                                            listElement.classList.toggle('hidden');
                                        }
                                    }}
                                >
                                    <div>
                                        <h5 className="m-0 text-medium-grey">Dette transporteur</h5>
                                        <div className="card-data font-20">
                                            {storeId
                                                ? filteredTotalDebt >= 0
                                                    ? filteredTotalDebt
                                                    : `- ${Math.abs(filteredTotalDebt)}`
                                                : organizationId
                                                ? filteredTotalDebt >= 0
                                                    ? filteredTotalDebt
                                                    : `- ${Math.abs(filteredTotalDebt)}`
                                                : ``}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="icon-toggle items-center"
                                    onClick={() => {
                                        const listElement = document.querySelector('.debt-list');
                                        if (listElement) {
                                            listElement.classList.toggle('hidden');
                                            const iconElement = document.querySelector('.icon-toggle');
                                            if (iconElement) {
                                                iconElement.classList.toggle('open');
                                            }
                                        }
                                    }}
                                >
                                    <div
                                        className={`icon-toggle items-center ${
                                            visibleList === 'debtList' ? 'open' : ''
                                        }`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setVisibleList((prev) => (prev === 'debtList' ? null : 'debtList'));
                                        }}
                                    >
                                        {visibleList === 'debtList' ? (
                                            <DownOutlined className="text-primary" />
                                        ) : (
                                            <RightOutlined className="text-primary" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <style>
                            {`
                                .debt-list.hidden {
                                    display: none;
                                }
                                .card.open + .debt-list {
                                    display: block;
                                }
                            `}
                        </style>
                    </>
                    {!storeId && !selectedVoucherStatus.includes('Non Utilisé') && (
                        <>
                            <div
                                className={`card card-total ${visibleList === 'warehouseList' ? 'highlight' : ''}`}
                                onClick={toggleWarehouseListVisibility}
                            >
                                <div className="text-primary font-24 w-48">
                                    <BankOutlined />
                                </div>
                                <div className="flex justify-between items-center w-full">
                                    <div>
                                        <h5 className="m-0 text-medium-grey">Compteur Entrepôt</h5>
                                        <div className="card-data font-20">
                                            {organizationId
                                                ? totalWarehouseCount >= 0
                                                    ? totalWarehouseCount
                                                    : `- ${Math.abs(totalWarehouseCount)}`
                                                : ``}
                                        </div>
                                    </div>
                                    <div
                                        className={`icon-toggle items-center ${
                                            visibleList === 'warehouseList' ? 'open' : ''
                                        }`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleWarehouseListVisibility();
                                        }}
                                    >
                                        {visibleList === 'warehouseList' ? (
                                            <DownOutlined className="text-primary" />
                                        ) : (
                                            <RightOutlined className="text-primary" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <>
                        {!storeId &&
                            !selectedVoucherStatus.includes('Non Utilisé') &&
                            parcPaletteData.map((item) => {
                                return (
                                    <React.Fragment key={item.id}>
                                        <div
                                            className={`card card-total ${
                                                visibleList === `parc-${item.id}` ? 'highlight' : ''
                                            } ${storeId ? 'open' : ''}`}
                                            onClick={() => {
                                                toggleParcListVisibility(item.id);
                                            }}
                                        >
                                            <div className="text-primary font-24 w-48">
                                                <PalettCount />
                                            </div>
                                            <div className="flex justify-between items-center w-full">
                                                <div>
                                                    <h5 className="m-0 text-medium-grey">
                                                        Compteur Parc Palettes - {item.name}
                                                    </h5>
                                                    <div className="card-data font-20">
                                                        {organizationId
                                                            ? !isNaN(item.count)
                                                                ? item.count >= 0
                                                                    ? item.count
                                                                    : `- ${Math.abs(item.count)}`
                                                                : 0
                                                            : ``}
                                                    </div>
                                                </div>
                                                <div
                                                    className={`icon-toggle items-center ${
                                                        visibleList === `parc-${item.id}` ? 'open' : ''
                                                    }`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        toggleParcListVisibility(item.id);
                                                    }}
                                                >
                                                    {visibleList === `parc-${item.id}` ? (
                                                        <DownOutlined className="text-primary" />
                                                    ) : (
                                                        <RightOutlined className="text-primary" />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            })}
                    </>
                </div>
                {!hideDetailLists && packageData.length > 0 && (
                    <List
                        className={`kpi-list ${visibleList === 'list' ? '' : 'hidden'}`}
                        grid={{
                            gutter: 1,
                            xs: 1,
                            sm: 3,
                            md: 4,
                            lg: 4,
                            xl: 5,
                            xxl: 5,
                        }}
                        dataSource={packageData.filter((item) => item.totalCount !== 0)}
                        pagination={{
                            pageSize: 10,
                        }}
                        renderItem={(item) => (
                            <Popover
                                content={
                                    <React.Fragment>
                                        <div className="popover-content">
                                            <span></span>
                                            <span>Modèle</span>
                                        </div>
                                        {Object.values(
                                            item.details.reduce<Record<string, { count: number; model: string }>>(
                                                (acc, detail) => {
                                                    const key = `${item.name}-${detail.model}`;
                                                    if (!acc[key]) {
                                                        acc[key] = { count: 0, model: detail.model };
                                                    }
                                                    acc[key].count += detail.count;
                                                    return acc;
                                                },
                                                {}
                                            )
                                        )
                                            .filter((aggregatedDetail) => aggregatedDetail.count !== 0)
                                            .map((aggregatedDetail, index) => (
                                                <div key={index} className="detail-item">
                                                    <div className="detail-count font-18 text-antd-blue">
                                                        <span>
                                                            {storeId
                                                                ? aggregatedDetail.count >= 0
                                                                    ? aggregatedDetail.count
                                                                    : `- ${Math.abs(aggregatedDetail.count)}`
                                                                : organizationId
                                                                ? aggregatedDetail.count > 0
                                                                    ? `- ${aggregatedDetail.count}`
                                                                    : Math.abs(aggregatedDetail.count)
                                                                : ``}
                                                        </span>
                                                    </div>
                                                    <span>{aggregatedDetail.model}</span>
                                                </div>
                                            ))}
                                    </React.Fragment>
                                }
                                showArrow={false}
                                placement="bottomLeft"
                                trigger="click"
                                overlayClassName="count-popover font-16"
                            >
                                <List.Item>
                                    <div className="card card-kpi highlight justify-between w-full">
                                        <div className="w-full pr-16">
                                            <h3 className="m-0 font-bold">{item.name}</h3>
                                            <div className="flex justify-between">
                                                <h5 className="m-0 text-medium-grey">Compteur</h5>
                                                <h5 className="m-0 text-medium-grey">Taux de restitution</h5>
                                            </div>
                                            <div className="flex justify-between">
                                                <div className="card-data font-20">
                                                    {storeId
                                                        ? item.totalCount >= 0
                                                            ? item.totalCount
                                                            : `- ${Math.abs(item.totalCount)}`
                                                        : organizationId
                                                        ? item.totalCount > 0
                                                            ? `- ${item.totalCount}`
                                                            : Math.abs(item.totalCount)
                                                        : ``}
                                                </div>
                                                <div className="card-data font-20">
                                                    <span className="text-black">
                                                        {!isNaN(item.percentage) ? `${Math.abs(item.percentage)}%` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <RightOutlined className="text-primary" />
                                    </div>
                                </List.Item>
                            </Popover>
                        )}
                    />
                )}
                {!hideDetailLists && packageDebt.length > 0 && (
                    <div className="parc-list-container">
                        <List
                            className={`debt-list ${visibleList === 'debtList' ? '' : 'hidden'}`}
                            grid={{
                                gutter: 1,
                                xs: 1,
                                sm: 3,
                                md: 4,
                                lg: 4,
                                xl: 5,
                                xxl: 5,
                            }}
                            dataSource={packageDebt.filter((item) => item.debt !== 0)}
                            pagination={{
                                pageSize: 10,
                            }}
                            renderItem={(item) => (
                                <Popover
                                    content={
                                        <React.Fragment>
                                            <div className="popover-content">
                                                <span></span>
                                                <span>Modèle</span>
                                            </div>
                                            {Object.values(
                                                item.details.reduce<Record<string, { debt: number; model: string }>>(
                                                    (acc, detail) => {
                                                        const key = `${item.name}-${detail.model}`;
                                                        if (!acc[key]) {
                                                            acc[key] = { debt: 0, model: detail.model };
                                                        }
                                                        acc[key].debt += detail.debt;
                                                        return acc;
                                                    },
                                                    {}
                                                )
                                            )
                                                .filter((aggregatedDetail) => aggregatedDetail.debt !== 0)
                                                .map((aggregatedDetail, index) => (
                                                    <div key={index} className="detail-item">
                                                        <div className="detail-count font-18 text-antd-blue">
                                                            <span>
                                                                {storeId
                                                                    ? aggregatedDetail.debt >= 0
                                                                        ? aggregatedDetail.debt
                                                                        : `- ${Math.abs(aggregatedDetail.debt)}`
                                                                    : organizationId
                                                                    ? aggregatedDetail.debt > 0
                                                                        ? aggregatedDetail.debt
                                                                        : `- ${Math.abs(aggregatedDetail.debt)}`
                                                                    : ``}
                                                            </span>
                                                        </div>
                                                        <span>{aggregatedDetail.model}</span>
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    }
                                    showArrow={false}
                                    placement="bottomLeft"
                                    trigger="click"
                                    overlayClassName="count-popover font-16"
                                >
                                    <List.Item>
                                        <div
                                            className="card card-kpi highlight justify-between w-full"
                                            style={{ marginLeft: '-15px' }}
                                        >
                                            <div className="w-full pr-16">
                                                <h3 className="m-0 font-bold">{item.name}</h3>
                                                <div className="flex justify-between">
                                                    <h5 className="m-0 text-medium-grey">Dette</h5>
                                                </div>
                                                <div className="flex justify-between">
                                                    <div className="card-data font-20">
                                                        {storeId
                                                            ? item.debt >= 0
                                                                ? item.debt
                                                                : `- ${Math.abs(item.debt)}`
                                                            : organizationId
                                                            ? item.debt > 0
                                                                ? item.debt
                                                                : `- ${Math.abs(item.debt)}`
                                                            : ``}
                                                    </div>
                                                </div>
                                            </div>
                                            <RightOutlined className="text-primary" />
                                        </div>
                                    </List.Item>
                                </Popover>
                            )}
                        />
                    </div>
                )}
                {!hideDetailLists && parcPalettData.length > 0 && visibleList?.startsWith('parc-') && (
                    <div className="parc-list-container">
                        <List
                            className={`parc-list`}
                            grid={{
                                gutter: 1,
                                xs: 1,
                                sm: 3,
                                md: 4,
                                lg: 4,
                                xl: 5,
                                xxl: 5,
                            }}
                            dataSource={matchingTypes.filter(
                                (item) => item.parcPalett === visibleList.replace('parc-', '')
                            )}
                            pagination={{
                                pageSize: 10,
                            }}
                            renderItem={(item) => (
                                <Popover
                                    content={
                                        <React.Fragment>
                                            <div className="popover-content">
                                                <span></span>
                                                <span>Modèle</span>
                                            </div>
                                            {Object.values(
                                                item.details.reduce<Record<string, { count: number; model: string }>>(
                                                    (acc, detail) => {
                                                        const key = `${item.name}-${detail.model}`;
                                                        if (!acc[key]) {
                                                            acc[key] = {
                                                                count: 0,
                                                                model: detail.model,
                                                            };
                                                        }
                                                        acc[key].count += detail.count;
                                                        return acc;
                                                    },
                                                    {}
                                                )
                                            )
                                                .filter((parc) => parc.count !== 0)
                                                .map((parc, index) => (
                                                    <div key={index} className="detail-item">
                                                        <div className="parc-count font-18 text-antd-blue">
                                                            <span>
                                                                {organizationId
                                                                    ? parc.count >= 0
                                                                        ? parc.count
                                                                        : `- ${Math.abs(parc.count)}`
                                                                    : ``}
                                                            </span>
                                                        </div>
                                                        <span>{parc.model}</span>
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    }
                                    showArrow={false}
                                    placement="bottomLeft"
                                    trigger="click"
                                    overlayClassName="count-popover font-16"
                                >
                                    <List.Item>
                                        <div
                                            className="card card-parc highlight justify-between w-full"
                                            style={{ marginLeft: '-15px' }}
                                        >
                                            <div className="w-full pr-16">
                                                <h3 className="m-0 font-bold">{item.name}</h3>
                                                <div className="flex justify-between">
                                                    <h5 className="m-0 text-medium-grey">Parc</h5>
                                                </div>
                                                <div className="flex justify-between">
                                                    <div className="card-data font-20">
                                                        {organizationId
                                                            ? item.count >= 0
                                                                ? item.count
                                                                : `- ${Math.abs(item.count)}`
                                                            : ``}
                                                    </div>
                                                </div>
                                            </div>
                                            <RightOutlined className="text-primary" />
                                        </div>
                                    </List.Item>
                                </Popover>
                            )}
                        />
                    </div>
                )}
                {!hideDetailLists && warehouseCounterData.length > 0 && visibleList === 'warehouseList' && (
                    <div className="parc-list-container">
                        <List
                            className="warehouse-list"
                            grid={{ gutter: 1, xs: 1, sm: 3, md: 4, lg: 4, xl: 5, xxl: 5 }}
                            dataSource={Object.values(
                                warehouseCounterData.reduce<
                                    Record<
                                        string,
                                        {
                                            type: string;
                                            totalCount: number;
                                            models: Array<{ model: string; count: number }>;
                                        }
                                    >
                                >((acc, item) => {
                                    if (!acc[item.type]) {
                                        acc[item.type] = { type: item.type, totalCount: 0, models: [] };
                                    }
                                    acc[item.type].totalCount += item.count;
                                    acc[item.type].models.push({ model: item.model, count: item.count });
                                    return acc;
                                }, {})
                            ).filter((item) => item.totalCount !== 0)}
                            pagination={{ pageSize: 10 }}
                            renderItem={(item) => (
                                <Popover
                                    content={
                                        <React.Fragment>
                                            <div className="popover-content">
                                                <span></span>
                                                <span>Modèle</span>
                                            </div>
                                            {Object.values(
                                                item.models.reduce<Record<string, { model: string; count: number }>>(
                                                    (acc, model) => {
                                                        if (!acc[model.model]) {
                                                            acc[model.model] = {
                                                                model: model.model,
                                                                count: 0,
                                                            };
                                                        }

                                                        acc[model.model].count += model.count;

                                                        return acc;
                                                    },
                                                    {}
                                                )
                                            )
                                                .filter((m) => m.count !== 0)
                                                .map((m, index) => (
                                                    <div key={index} className="detail-item">
                                                        <div className="detail-count font-18 text-antd-blue">
                                                            <span>
                                                                {m.count >= 0 ? m.count : `- ${Math.abs(m.count)}`}
                                                            </span>
                                                        </div>
                                                        <span>{m.model}</span>
                                                    </div>
                                                ))}
                                        </React.Fragment>
                                    }
                                    showArrow={false}
                                    placement="bottomLeft"
                                    trigger="click"
                                    overlayClassName="count-popover font-16"
                                >
                                    <List.Item>
                                        <div
                                            className="card card-kpi highlight justify-between w-full"
                                            style={{ marginLeft: '-15px' }}
                                        >
                                            <div className="w-full pr-16">
                                                <h3 className="m-0 font-bold">{item.type}</h3>
                                                <div className="flex justify-between">
                                                    <h5 className="m-0 text-medium-grey">Compteur Entrepôt</h5>
                                                </div>
                                                <div className="flex justify-between">
                                                    <div className="card-data font-20">
                                                        {organizationId
                                                            ? item.totalCount >= 0
                                                                ? item.totalCount
                                                                : `- ${Math.abs(item.totalCount)}`
                                                            : ``}
                                                    </div>
                                                </div>
                                            </div>
                                            <RightOutlined className="text-primary" />
                                        </div>
                                    </List.Item>
                                </Popover>
                            )}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default PackageCount;
